import { i18n } from 'vue-lang-router'
import moment from 'moment-timezone'
import store from '@/store'

moment.locale(i18n.global.locale)

const formatTitle = (event, includeTime = true) => {
  const titleParts = []

  if (includeTime) {
    titleParts.push(formatTime(event.startTime))
  }

  if (event.title) {
    titleParts.push(event.title)
  } else if (event.serviceGroup) {
    titleParts.push(i18n.global.t('serviceGroups.' + event.serviceGroup))
  }

  let title = titleParts.join(': ')

  if (event.pet) {
    title += ` (${event.pet.name})`
  }

  return title.charAt(0).toUpperCase() + title.substring(1)
}

const formatDate = (timeString, withDate = true, short = true) => {
  let dayFormat = 'dddd'
  if (short) {
    dayFormat = 'dd'
  }

  const string = moment.tz(timeString, 'Europe/Brussels').calendar(null, {
    sameDay: `[${i18n.global.t('today')}]` + (withDate ? `, ${dayFormat} D MMM YYYY` : ''),
    nextDay: `[${i18n.global.t('tomorrow')}]` + (withDate ? `, ${dayFormat} D MMM YYYY` : ''),
    nextWeek: `[${i18n.global.t('nextWeek')}] dddd` + (withDate ? ', D MMM YYYY' : ''),
    lastDay: `[${i18n.global.t('yesterday')}]` + (withDate ? `, ${dayFormat} D MMM YYYY` : ''),
    lastWeek: `${dayFormat} D MMM YYYY`,
    sameElse: `${dayFormat} D MMM YYYY`
  })

  return string.charAt(0).toUpperCase() + string.substring(1)
}

const formatTime = timeString => {
  return moment.tz(timeString, 'Europe/Brussels').format('HH[h]mm')
}

const getDay = timeString => {
  return moment.tz(timeString, 'Europe/Brussels').format('DD')
}

const getMonth = timeString => {
  return moment.tz(timeString, 'Europe/Brussels').format('MMM')
}

export default {
  formatTitle,
  formatDate,
  formatTime,
  getDay,
  getMonth
}
